/**
 * <s-image-guard> — discourages casual copying of store imagery.
 *
 * Blocks the right-click menu and drag-to-save on images inside the element.
 * Long-press save on mobile and image selection are switched off with CSS on
 * the host (see the classes in layout/theme.liquid). This deters casual saving;
 * it cannot stop screenshots or determined copying.
 */
class SImageGuard extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const isImage = (target) => target instanceof Element && target.closest('img, picture, video');

    this.addEventListener('contextmenu', (event) => {
      if (isImage(event.target)) event.preventDefault();
    }, opts);
    this.addEventListener('dragstart', (event) => {
      if (isImage(event.target)) event.preventDefault();
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-image-guard')) {
  customElements.define('s-image-guard', SImageGuard);
}
